// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EnergyCalculation {
  padding-inline: 20px;
  height: 100dvh;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom: 20px;
}
.EnergyCalculation__Banner {
  height: 98px;
  display: flex;
  padding: 11px 16px 0px 16px;
  align-items: center;
  border-radius: 12px;
  gap: 8px;
  border: 1px solid #f2f2f2;
  border-radius: 8px;
  background: #e6f7ef;
  flex: 4;
}
.EnergyCalculation__LeftContent {
  display: flex;
  flex: 1;
}
.EnergyCalculation__Middle {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.EnergyCalculation__Title {
  color: #1e1e1e;
  font-family: Outfit;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.EnergyCalculation__SubTitle {
  color: #8c8c8c;
  font-family: Outfit;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.EnergyCalculation__Label {
  color: #8c8c8c;
  font-family: Outfit;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding-top: 32px;
  padding-bottom: 32px;
}
.EnergyCalculation__LabelBold {
  color: #1e1e1e;
  font-family: Outfit;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.EnergyCalculation__InputLabel {
  color: #8c8c8c;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 16px;
  font-family: Outfit;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.EnergyCalculation__RightContent {
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 3;
}
.EnergyCalculation__Values {
  display: flex;
  gap: 8px;
}
.EnergyCalculation__EnergyButton {
  display: flex;
  height: 32px;
  padding: 8px 12px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  background: #f2f2f2;
  color: #333;
  font-family: Outfit;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.EnergyCalculation__Img {
  height: 87px;
}
.EnergyCalculation__Amount {
  color: #00aa74;
  text-align: center;
  /* Body/16px medium */
  font-family: Outfit;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.EnergyCalculation__Input {
  padding: 16px 0px;
}
.EnergyCalculation__isZeroTarrif {
  color: #1e1e1e;
  font-family: Outfit;
  font-size: 1rem;
  font-weight: 500;
  text-align: center;
  padding: 10px;
}

.customContainerStyle {
  margin-top: -22px;
}`, "",{"version":3,"sources":["webpack://./src/Views/AfterAuth/StartChargeingView/EnergyCalculations/EnergyCalculation.scss"],"names":[],"mappings":"AAAA;EACI,oBAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,oBAAA;AACJ;AACI;EACI,YAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,OAAA;AACR;AACI;EACI,aAAA;EACA,OAAA;AACR;AACI;EACI,aAAA;EACA,sBAAA;EACA,QAAA;AACR;AACI;EACI,cAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AACR;AACI;EACI,cAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AACR;AACI;EACI,cAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;AACR;AACI;EACI,cAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AACR;AACI;EACI,cAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAAR;AAEI;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,OAAA;AAAR;AAEI;EACI,aAAA;EACA,QAAA;AAAR;AAEI;EACI,aAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAAR;AAEI;EACI,YAAA;AAAR;AAEI;EACI,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAAR;AAEI;EACI,iBAAA;AAAR;AAII;EACI,cAAA;EACA,mBAAA;EACA,eAAA;EAEA,gBAAA;EAEA,kBAAA;EACA,aAAA;AAJR;;AAOA;EACI,iBAAA;AAJJ","sourcesContent":[".EnergyCalculation {\n    padding-inline: 20px;\n    height: 100dvh;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    padding-bottom: 20px;\n\n    &__Banner {\n        height: 98px;\n        display: flex;\n        padding: 11px 16px 0px 16px;\n        align-items: center;\n        border-radius: 12px;\n        gap: 8px;\n        border: 1px solid #f2f2f2;\n        border-radius: 8px;\n        background: #e6f7ef;\n        flex: 4;\n    }\n    &__LeftContent {\n        display: flex;\n        flex: 1;\n    }\n    &__Middle {\n        display: flex;\n        flex-direction: column;\n        gap: 8px;\n    }\n    &__Title {\n        color: #1e1e1e;\n        font-family: Outfit;\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: normal;\n    }\n    &__SubTitle {\n        color: #8c8c8c;\n        font-family: Outfit;\n        font-size: 12px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: normal;\n    }\n    &__Label {\n        color: #8c8c8c;\n        font-family: Outfit;\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: normal;\n        padding-top: 32px;\n        padding-bottom: 32px;\n    }\n    &__LabelBold {\n        color: #1e1e1e;\n        font-family: Outfit;\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: normal;\n    }\n    &__InputLabel {\n        color: #8c8c8c;\n\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        padding-bottom: 16px;\n        font-family: Outfit;\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: normal;\n    }\n    &__RightContent {\n        display: flex;\n        flex-direction: column;\n        gap: 10px;\n        flex: 3;\n    }\n    &__Values {\n        display: flex;\n        gap: 8px;\n    }\n    &__EnergyButton {\n        display: flex;\n        height: 32px;\n        padding: 8px 12px;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        border-radius: 12px;\n        background: #f2f2f2;\n        color: #333;\n        font-family: Outfit;\n        font-size: 12px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: normal;\n    }\n    &__Img {\n        height: 87px;\n    }\n    &__Amount {\n        color: #00aa74;\n        text-align: center;\n        /* Body/16px medium */\n        font-family: Outfit;\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: normal;\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n    }\n    &__Input {\n        padding: 16px 0px;\n    }\n    &__RechargeButton {\n    }\n    &__isZeroTarrif {\n        color: #1e1e1e;\n        font-family: Outfit;\n        font-size: 1rem;\n\n        font-weight: 500;\n\n        text-align: center;\n        padding: 10px;\n    }\n}\n.customContainerStyle{\n    margin-top: -22px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
